<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <div class="text-left">
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/">
          <v-btn
            color="secondary"
            class="text-right"
            style="width:250px"
          >
            Back
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <div class="text-left">
        </div>
      </v-col>
      <v-col cols="6">
        <v-btn
          color="primary"
          class="text-right"
          style="width:250px;"
          disabled
        >
          2026
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <div class="text-left">
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/archive/2025">
          <v-btn
            color="primary"
            class="text-right"
            style="width:250px;"
          >
            2025
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

//vue 3 style
import { ref } from 'vue'

export default {
  name: 'Archive',
  setup() {
  }
}
</script>
